import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, markRaw } from 'vue';
import OrderCardLens from './OrderCardLens.vue';
import OrderCardLensCare from './OrderCardLensCare.vue';
import OrderCardMultiPower from './OrderCardMultiPower.vue';
import type { OrderItem } from '@/models/webshop.model';
import { PRODUCT_CATEGORY_SLUG_LENS_CARE } from '@/constants/webshop';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
    item: {},
    isLoading: { type: Boolean },
    category: {},
    editable: { type: Boolean, default: true },
    isSelected: { type: Boolean, default: false }
  },
  emits: ['remove-item', 'update-item', 'select-item'],
  setup(__props: any) {

const props = __props;



const isLensCare = computed(() => props.category === PRODUCT_CATEGORY_SLUG_LENS_CARE);
const isMultiPower = computed(() => {
  try {
    const powerQuantities = props.item.powerQuantities;
    if (!powerQuantities) {
      return false;
    }
    return powerQuantities.length > 0;
  } catch (e) {
    return false;
  }
});

const cardDusk = computed(() => {
  if (isMultiPower.value) {
    return 'multi-power-card';
  }
  if (isLensCare.value) {
    return 'lens-care-card';
  }
  return 'lens-card';
});

const componentMap = {
  'multi-power': markRaw(OrderCardMultiPower),
  'lens-care': markRaw(OrderCardLensCare),
  lens: markRaw(OrderCardLens)
};

const resolveComponent = computed(() => {
  if (isMultiPower.value) {
    return componentMap['multi-power'];
  }
  if (isLensCare.value) {
    return componentMap['lens-care'];
  }
  return componentMap.lens;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(resolveComponent.value), {
    item: props.item,
    "is-loading": props.isLoading,
    category: _ctx.category,
    editable: props.editable,
    "is-selected": props.isSelected,
    "data-dusk": cardDusk.value,
    onRemoveItem: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove-item', $event))),
    onUpdateItem: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-item', $event))),
    onSelectItem: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select-item', $event)))
  }, null, 40, ["item", "is-loading", "category", "editable", "is-selected", "data-dusk"]))
}
}

})